<!-- 表口径列表 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('抄表员')">
              <a-input :placeholder="$t('请输入抄表员')" v-model="queryParam.mtCaliber"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="12" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('抄表日期')">
                <a-range-picker
                    v-model="date"
                    format="YYYY-MM-DD"
                    :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                    @change="onDateRangeChange"
                    @ok="onOk"
                />
            </a-form-item>
        </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import moment from 'moment'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import {isUndefined} from'@/utils/validate'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  export default {
    name: 'MeterCaliberList',
    mixins: [JeecgListMixin],
    components: {
    },
    data () {
      return {
        description: 'meter_caliber管理页面',
        url: {
          list: "/jeecg-charge/meter/meterCaliber/list",
          delete: "/jeecg-charge/meter/meterCaliber/delete",
          deleteBatch: "/jeecg-charge/meter/meterCaliber/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterCaliber/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterCaliber/importExcel",
        },
        date: [],
        disableMixinCreated: true
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:(t,r,index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'mtCaliber'
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'mtCaliberUnit',
            customRender:(t,r,index) => {
              let data = {"0": "mm","1":"m³"}
              if(isUndefined(typeof data[t])) {
                return this.$t("其他")
              }
              return data[t]
            }
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'standFlow'
          },{
            title: this.$t('表类型'),
            align:"center",
            dataIndex: 'maxFlow'
          },{
            title: this.$t('水表至数'),
            align:"center",
            dataIndex: 'warnTopDay'
          },{
            title: this.$t('抄表时间'),
            align:"center",
            dataIndex: 'warnLowDay'
          },{
            title: this.$t('安装位置'),
            align:"center",
            dataIndex: 'deviceLocation'
          },{
            title: this.$t('抄表员'),
            align:"center",
            dataIndex: 'operator'
          },{
            title: this.$t('照片记录'),
            align:"center",
            dataIndex: 'image'
          },{
            title: this.$t('备注'),
            align:"center",
            dataIndex: 'remark'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
        onOk(value) {
            console.log('onOk:', value);
        },
    },
    created() {
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>